var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBMinus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 23,
    viewBox: "0 0 15 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.945312 21.5596L13.4453 20.0596",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0254 0.0800781V1.03613H9.86523V0.0800781H14.0254Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.16
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.951172 17.5598V2.28711H6.79776C7.90146 2.28711 8.81871 2.46111 9.54954 2.80913C10.2853 3.15217 10.8347 3.62198 11.1976 4.21857C11.5655 4.81516 11.7495 5.4913 11.7495 6.24698C11.7495 6.86843 11.6301 7.40039 11.3915 7.84286C11.1529 8.28036 10.8322 8.63583 10.4295 8.90927C10.0268 9.18271 9.57688 9.37908 9.07972 9.4984V9.64755C9.62163 9.67738 10.1412 9.84393 10.6383 10.1472C11.1404 10.4455 11.5506 10.8681 11.8688 11.415C12.187 11.9618 12.3461 12.623 12.3461 13.3986C12.3461 14.1891 12.1547 14.9 11.7718 15.5314C11.389 16.1578 10.8123 16.6525 10.0417 17.0154C9.27113 17.3784 8.30167 17.5598 7.13335 17.5598H0.951172ZM3.71786 15.248H6.69336C7.69762 15.248 8.42099 15.0566 8.86346 14.6738C9.3109 14.286 9.53462 13.7889 9.53462 13.1824C9.53462 12.7299 9.42276 12.3223 9.19904 11.9593C8.97532 11.5914 8.65714 11.3031 8.2445 11.0943C7.83185 10.8805 7.33967 10.7736 6.76793 10.7736H3.71786V15.248ZM3.71786 8.78249H6.45472C6.932 8.78249 7.36204 8.69549 7.74485 8.52148C8.12766 8.34251 8.42844 8.09144 8.64719 7.76829C8.87092 7.44016 8.98278 7.05238 8.98278 6.60494C8.98278 6.01332 8.77397 5.5261 8.35636 5.14329C7.94372 4.76048 7.32972 4.56907 6.51438 4.56907H3.71786V8.78249Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBMinus);
export default __webpack_public_path__ + "static/media/b-minus.32df5c7503ee8e28cef92219ac2d19c8.svg";
export { ForwardRef as ReactComponent };